<template>
  <div v-if="original_data && new_data">
    <span v-for="(value, key) in original_data" :key="key">
      <span><strong class="key">{{ key | key_transform }} : </strong></span>
      <del>{{ value }}</del>
      <span> {{ getNewValue(key) }}</span><br>
    </span>
    <tag-properties v-if="should_show_tags" :tag-properties="tag_properties" />
    <span v-if="rowProperties.attributes.feed && rowProperties.old.feed">
      <strong class="key">Feed : </strong>
      <del> <a :href="`feeds/${rowProperties.old.feed.uuid}/edit`">{{ rowProperties.old.feed.name }}</a></del>
      <a :href="`feeds/${rowProperties.attributes.feed.uuid}/edit`">{{ rowProperties.attributes.feed.name }}</a>
      <br>
    </span>

    <span v-if="rowProperties.attributes.artwork || rowProperties.old.artwork">
      <strong class="key">Artwork : </strong>
      <del v-if="rowProperties.old.artwork">{{ rowProperties.old.artwork.name }}</del><span v-if="rowProperties.attributes.artwork"> {{ rowProperties.attributes.artwork.name }}</span>
      <br>
    </span>
  </div>
</template>

<script>
import PropertiesMixin from "VueMixins/ActivityLog/PropertiesMixin";
import TagProperties from "VuePartials/ActivityLog/TagProperties";

export default {
  components: { TagProperties },
  mixins: [PropertiesMixin],
  props: {
    rowProperties: {
      type: Object,
      required: true,
    },
  },
  computed: {
    original_data() {
      return this.filtered_row_properties.old;
    },
    new_data() {
      return this.filtered_row_properties.attributes;
    },
  },
  methods: {
    getNewValue(key) {
      return this.new_data[key] ? this.new_data[key] : "Removed";
    },
  },
};
</script>

<style lang="scss" scoped>
  .key {
    text-transform: capitalize;
  }
</style>
